// extracted by mini-css-extract-plugin
module.exports = {"link-button":"text-button_link-button__bx_0v","bold":"text-button_bold__EiQ_W"};